export const API_BASE_URL =
  process.env.REACT_APP_API_BASE_URL ||
  'https://4eeq3jtica.execute-api.ap-south-1.amazonaws.com/mahasuchi/api';

export const SUPPORT_PHONE = '8421313113';
export const SUPPORT_EMAIL = 'support@kharedivikri.com';
export const BRAND_NAME = 'Kharedivikri';

export const REPORT_FEE_INR = 1299;
export const GST_RATE = 0.18;
export const REPORT_TOTAL_INR = Number((REPORT_FEE_INR * (1 + GST_RATE)).toFixed(2));

export const CUSTOMER_TOKEN_KEY = 'kharedivikri_customer_token';
export const LEAD_KEY = 'kharedivikri_lead';
export const RECORDS_KEY = 'kharedivikri_records';
export const CTX_KEY = 'kharedivikri_ctx';
export const PAYMENT_TOKEN_KEY = 'kharedivikri_payment_token';

export const getStoredCustomerToken = () =>
  sessionStorage.getItem(CUSTOMER_TOKEN_KEY) || localStorage.getItem(CUSTOMER_TOKEN_KEY) || '';

export const setStoredCustomerToken = (token) => {
  const clean = String(token || '').trim();
  if (!clean) return;
  sessionStorage.setItem(CUSTOMER_TOKEN_KEY, clean);
  localStorage.setItem(CUSTOMER_TOKEN_KEY, clean);
};

export const buildCustomerHeaders = (base = {}) => {
  const headers = { ...base };
  const token = getStoredCustomerToken();
  if (token) headers.Authorization = `Bearer ${token}`;
  return headers;
};

export const customerFetch = (url, opts = {}) =>
  fetch(url, {
    credentials: 'include',
    ...opts,
    headers: buildCustomerHeaders(opts.headers || {}),
  });

export const sleepMs = (ms) => new Promise((resolve) => setTimeout(resolve, ms));

export function leadSaveBackoffMs(attemptIndex0) {
  const capMs = 25_000;
  return Math.min(800 * 1.65 ** Math.min(attemptIndex0, 16), capMs);
}

export function persistSession(key, value) {
  const str = typeof value === 'string' ? value : JSON.stringify(value);
  sessionStorage.setItem(key, str);
  localStorage.setItem(key, str);
}

export function readSession(key, fallback = '') {
  return sessionStorage.getItem(key) || localStorage.getItem(key) || fallback;
}

export function clearPaymentSession() {
  [RECORDS_KEY, CTX_KEY, PAYMENT_TOKEN_KEY].forEach((k) => {
    sessionStorage.removeItem(k);
    localStorage.removeItem(k);
  });
}
